var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { SystemIcon } from '@storeblocks/icon';
import { RowBase, HeaderLevel, Header, Content } from './styled';
import Collapse from './Collapse';
function Row(_a) {
    var { id, open, headingAriaLevel, header, content, children, icons = 'plusminus', headerProps, sectionProps, contentProps } = _a, props = __rest(_a, ["id", "open", "headingAriaLevel", "header", "content", "children", "icons", "headerProps", "sectionProps", "contentProps"]);
    const icon = useMemo(() => {
        let iconType = '';
        switch (icons) {
            case 'chevron':
                iconType = !open ? 'chevron-down' : 'chevron-up';
                break;
            default:
                iconType = !open ? 'add' : 'minus';
                break;
        }
        return iconType;
    }, [open, icons]);
    const sectionId = useMemo(() => `${id}-section`, [id]);
    return (React.createElement(RowBase, Object.assign({}, props),
        React.createElement(HeaderLevel, { role: "heading", "aria-level": headingAriaLevel },
            React.createElement(Header, Object.assign({ "$isOpen": open, id: id, "aria-expanded": open, "aria-controls": sectionId }, headerProps),
                header,
                React.createElement(SystemIcon, { name: icon }))),
        React.createElement(Collapse, Object.assign({ role: "region", id: sectionId, "aria-labelledby": id, isOpen: open }, sectionProps),
            React.createElement(Content, Object.assign({}, contentProps), content || children))));
}
export default Row;
